import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    usuario: window.localStorage.getItem('usuario') || '',
    tipo: window.localStorage.getItem('tipo') || 'admin',
    token: window.localStorage.getItem('authenticated') || '',
  },
  getters: {
    loggedIn(state) {
      return !!state.token && state.token !== 'false';
    },
    tipoUsuario(state) {
      return state.tipo;
    },
    nombreUsuario(state) {
      return state.usuario || 'Usuario';
    },
  },
  mutations: {
    settipo(state, payload) {
      state.tipo = payload;
      window.localStorage.setItem('tipo', payload);
    },
    setusuario(state, payload) {
      state.usuario = payload;
      window.localStorage.setItem('usuario', payload);
    },
    settoken(state, payload) {
      state.token = payload;
      window.localStorage.setItem('authenticated', payload);
    },
    logout(state) {
      state.usuario = '';
      state.tipo = '';
      state.token = '';
      window.localStorage.removeItem('authenticated');
      window.localStorage.removeItem('usuario');
      window.localStorage.removeItem('tipo');
    },
  },
  actions: {},
});
